// Images that only load inside the sender's mail session (Gmail contact photos
// and UI sprites); here they can only ever render as broken icons.
const SESSION_ONLY_IMAGES = [
	/^https?:\/\/mail\.google\.com\//i,
	/^https?:\/\/lh\d+\.googleusercontent\.com\/cm\//i,
]

// One blank line is a paragraph break. Longer runs are chrome the sender's
// client hid with its own stylesheet, e.g. a Gmail conversation pasted into a reply.
const MAX_BREAKS_IN_A_ROW = 2

const VISIBLE_TEXT = /[^\s​-‍﻿]/
const RUN_BOUNDARY_TAGS = new Set(["HR", "IMG", "LI", "PRE", "TD", "TH"])

const collapseBreakRuns = (root: HTMLElement) => {
	const extra: Element[] = []
	let run: Element[] = []
	const endRun = () => {
		extra.push(...run.slice(MAX_BREAKS_IN_A_ROW))
		run = []
	}

	const walker = root.ownerDocument.createTreeWalker(
		root,
		NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
	)
	for (let node = walker.nextNode(); node; node = walker.nextNode()) {
		if (node.nodeType === Node.TEXT_NODE) {
			if (VISIBLE_TEXT.test(node.textContent ?? "")) endRun()
			continue
		}
		const tag = (node as Element).tagName
		if (tag === "BR") run.push(node as Element)
		else if (RUN_BOUNDARY_TAGS.has(tag)) endRun()
	}
	endRun()

	for (const br of extra) br.remove()
}

export const tidyEmailLayout = (root: HTMLElement): void => {
	for (const img of root.querySelectorAll("img")) {
		const src = img.getAttribute("src") ?? ""
		if (SESSION_ONLY_IMAGES.some((pattern) => pattern.test(src))) img.remove()
	}
	collapseBreakRuns(root)
}

export const hideBrokenImage = (img: HTMLImageElement): void => {
	img.style.setProperty("display", "none", "important")
}
